import { AxiosError, InternalAxiosRequestConfig } from 'axios'
import Cookies from 'js-cookie'
import { useEffect, useMemo, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { axios } from '../api'
import { useGetAtoken } from '../api/unauth'
import { DefaultParam } from '../components/Search'
import { jwtDecode } from "jwt-decode";
import { useAuth } from '../store'

type Func = () => void

export const useAxios = () => {
  const navigate = useNavigate()
  const { mutateAsync: getAtoken } = useGetAtoken()
  const setAuth = useAuth((store) => store.setAuth)
  const stateRef = useRef('')
  const reqQ = useRef<Func[]>([])
  const resQ = useRef<Func[]>([])

  const addHeaderToken = (config: InternalAxiosRequestConfig<any>): InternalAxiosRequestConfig<any> => {
    config.headers.set('Authorization', stateRef.current)
    return config
  }

  const addAtoken = async (type: string) => {
    try {
      stateRef.current = await getAtoken(await Cookies.get('RT'))
      const { role, username, sub } = jwtDecode<{ role: string; username:string, sub:string }>(stateRef.current);
      setAuth({role: role, username: username, Id: sub })
      if (type === 'request') reqQ.current.forEach((requset) => requset())
      if (type === 'response') resQ.current.forEach((requset) => requset())
    } catch (error) {
      await Cookies.remove('RT')
      window.location.replace('/unauth/signin')
    } finally {
      reqQ.current = []
      resQ.current = []
    }
  }
  useMemo(() => {
    stateRef.current = ''
    const onReqFullFilled = async (config: InternalAxiosRequestConfig<any>): Promise<InternalAxiosRequestConfig<any>> => {
      if (stateRef.current !== '') return addHeaderToken(config)
      if (!reqQ.current.length) addAtoken('request')
      return await new Promise((res) => reqQ.current.push(() => res(addHeaderToken(config))))
    }

    const onResRejected = async (err: AxiosError): Promise<InternalAxiosRequestConfig<any>> => {
      if (err.response?.status !== 401) return Promise.reject(err)
      if (!resQ.current.length) addAtoken('response')
      return await new Promise((res) => resQ.current.push(() => res(axios.main(addHeaderToken(err.config as InternalAxiosRequestConfig<any>)))))
    }

    axios.main.interceptors.request.use(onReqFullFilled, undefined)
    axios.main.interceptors.response.use(undefined, onResRejected)
  }, [Cookies.get('RT')])
}

export const useGetQueryStr = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const queryParams = new URLSearchParams(location.search)

  const changeQuery = (name: string, value: string | number) => {
    queryParams.set(name, value.toString())
    navigate(`?${queryParams}`)
  }

  const changeObjectQuery = (param:DefaultParam) => {
    Object.entries(param).forEach(([key, value]) => value === "" ? queryParams.delete(key) : queryParams.set(key, value.toString()) )
    queryParams.delete('pageNo')
    navigate(`?${queryParams}`)
  }

  return { location, navigate, queryParams, changeQuery, changeObjectQuery }
}

type KeyMapping = {
  [key: string]: string
}

const keyMapping: KeyMapping = {
  password: '비밀번호',
  loginId: '로그인 아이디',
  role: '역할',
  passwordCheck: '비밀번호 확인',
  userDesc: '비고',
  userName: '사용자 이름',
  newPassword: "새 비밀번호",
  newPasswordCheck: "새 비밀번호 확인",
  partName:"소속명",
  groupName:"그룹명",
  driveNumber: "차랑변호",
  message: ''
}

export const useModalApiError = (error: unknown,setErrorMsg:(errorArray:string[])=>void) => {
  if (error instanceof Error) {
    const axiosError = error as { response?: { data?: KeyMapping, status?:number } }
    if(axiosError.response && Number(axiosError.response.status) >= 500){
      setErrorMsg(["서버 통신 에러"])
    } else if (axiosError.response && axiosError.response.data) {
      const errorArray = []
      for (const key in axiosError.response.data) errorArray.push(`${keyMapping[key]} ${axiosError.response.data[key]}`)
      setErrorMsg(errorArray)
      console.log('error', axiosError.response.data)
    } else {
      if(axiosError.response && axiosError.response.status === 403) setErrorMsg(["권한 없음"])
      else setErrorMsg(["서버 통신 에러"])
      console.log('An error occurred:', error.message)
    }
  } else {
    setErrorMsg(["서버 통신 에러"])
    console.log('An unexpected error occurred')
  }
}

export const useAuthCheck = () => {

  //리프래쉬토큰으로 해보자. 부작용없는지 체크부탁...
  let { role, loginId } = { role:'', loginId:'' }
  try {
    const a  = jwtDecode<{ role: string; sub:string }>(Cookies.get('RT'));
    role = a.role
    loginId = a.sub
  } catch (error) {
    Cookies.remove('RT')
    //navigate('/unauth/signin')
  }
  // const role = useAuth((store) => store.role)
  // const loginId = useAuth((store) => store.Id)
  const getRoleNumber = (role:string) => 
             role === "ROLE_USER" ? 0b1 :
             role === "ROLE_ADMIN_GROUP" ? 0b10 :
             role === "ROLE_ADMIN_PART" ? 0b100 :
             role === "ROLE_ADMIN_SUPER" ? 0b1000 :
             role === "ROLE_INIT" ? 0b10000  
             : 0
  const checkAuth = (passRole:string) => (getRoleNumber(role) & parseInt(passRole, 2)) > 0
  return { checkAuth, loginId }
}

export const usePreventHtmlScroll = () => {
  useEffect(() => {
    document.documentElement.style.overflow = "hidden"
    return () => {
      document.documentElement.style.overflow = ""
    }
  }, [])
}
